export default __webpack_public_path__ + "static/media/scenario2_table.525c078f.svg";